import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import * as animations from '../../animations';

enum Key {
  Backspace = 8,
  Tab = 9,
  Enter = 13,
  Shift = 16,
  Escape = 27,
  ArrowLeft = 37,
  ArrowRight = 39,
  ArrowUp = 38,
  ArrowDown = 40
}

@Component({
  selector: 'tr-navbar',
  animations: [animations.slideInRightAnimation],
  templateUrl: './navbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  //styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {

  @Output() logout = new EventEmitter();
  @Input() staticText: string;
  @Input() multipleOffers: {starters:'',};
 /* @Input() appVersion = {
    semver: '',
    isNewAvailable: false,
    checkingForVersion: false
  };*/
    @Input() appVersion ={
      userID: '',
        starterID: '',
        lastLogin: '',
        password: '',
        subPortal: '',
        starterJobTitle: '',
    }
  @Output() versionUpdate = new EventEmitter();
  @Output() versionCheck = new EventEmitter();
  @Output() fn_loadOffer  = new EventEmitter<any>();

  hide = true;

  constructor (private router: Router) {}


  logoutClicked(): void {
   // console.log(this.appVersion);

    this.logout.emit(null);
  }

  goHome() {
    this.router.navigateByUrl('/');
  }


  navigateTo(routeName: string): void {
    this.router.navigateByUrl('/', { skipLocationChange: true });
    setTimeout(() => this.router.navigate([`/${routeName}`]));
  }

  @HostListener('keyup', ['$event'])
  handleKeyPress(event: KeyboardEvent) {
    if (event.keyCode === Key.Escape) {
      this.hideMenu();
    }
  }

  hideMenu() {
    this.hide = true;
  }

  toggleMenu() {
    this.hide = !this.hide;
  }

  handleVersionUpdate() {
    this.versionUpdate.emit();
  }

  handleVersionCheck() {
    this.versionCheck.emit();
  }

  handleLoadOffer(someval: string, jobTitle: string) {
    console.log(this.appVersion.starterJobTitle);
    this.fn_loadOffer.emit({ starterid: someval, userid: this.appVersion.userID, jobtitle: jobTitle });
    // window.alert(someval);
     // this.navigateTo('https://services-v7.bigredsky.com/BigRedSkyOnboarding/TestAllenOnboardingPortalAPI/web/index.php/api/user/756/starter/1076/stage/2/page/1');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/navbar/navbar.component.ts